import React, { PureComponent } from 'react'
import { setup } from 'bem-cn';

const block = setup({
    mod: '--'
})

const b = block('Checkbox')

export default class Checkbox extends PureComponent {
    render() {

        const { enabled } = this.props

        return (
            <span className={b({ checked: enabled })}>
                <svg className={b('icon')} height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                    <g className={b('checked-icon')}>
                        <path className={b('icon-box')} d="M0 4.01C0 2.9.9 2 1.992 2H11l-1 1H1.998C1.448 3 1 3.456 1 3.995v8.01c0 .55.456.995.995.995h8.01c.55 0 .995-.458.995-.994V9.5l1-1V12c0 1.104-.902 2-2.01 2H2.01C.9 14 0 13.098 0 11.99V4.01z"
                            fill="currentColor" fillRule="evenodd"></path>
                        <path className={b('icon-check')} d="M3.5 6l3 3 7-7L15 3.5 6.5 12 2 7.5"></path>
                    </g>
                    <g className={b('unchecked-icon')}>
                        <path className={b('icon-box')} d="M0 4.01C0 2.9.902 2 2.01 2h7.98C11.1 2 12 2.902 12 4.01v7.98C12 13.1 11.098 14 9.99 14H2.01C.9 14 0 13.098 0 11.99V4.01zm1-.015c0-.55.456-.995.995-.995h8.01c.55 0 .995.456.995.995v8.01c0 .55-.456.995-.995.995h-8.01c-.55 0-.995-.456-.995-.995v-8.01z"
                            fill="currentColor" fillRule="evenodd"></path>
                    </g>
                </svg>
            </span>
        )
    }
}